import * as qs from 'app/lib/helperjs';

const TRIGGER = 'data-dialog';
const DIALOG = 'data-dialog-name';
const CLOSE = '[data-dialog-close]';
const OVERLAY = '.js-dialog-overlay';
const ACTIVE_CLASS = 'active';
const BODY_CLASS = 'dialog-opened';

export const Dialog = () => {
    const clickHandler = (dialogName) => () => {
        const dialog = qs.querySelector(`[${DIALOG}="${dialogName}"]`);

        if (dialog) {
            dialog.classList.add(ACTIVE_CLASS);
            document.body.classList.add(BODY_CLASS);
        }
    }

    window.addEventListener('dialog-new-trigger', evt => {
        const dialogName = evt.detail.target;
        if (!dialogName) {
            return;
        }

        qs.querySelector(`[${TRIGGER}="${dialogName}"]`).addEventListener('click', clickHandler(dialogName));
    });

    qs.querySelectorAll(`[${TRIGGER}]`).forEach(trigger => {
        const dialogName = trigger.getAttribute(TRIGGER);

        trigger.addEventListener('click', clickHandler(dialogName))
    });

    const closeHandler = () => {
        qs.querySelectorAll(`[${DIALOG}]`).forEach(dialog => {
            dialog.classList.remove(ACTIVE_CLASS);
        });
        document.body.classList.remove(BODY_CLASS);
    };

    qs.querySelectorAll(CLOSE).forEach(closeBtn => {
        closeBtn.addEventListener('click', closeHandler);
    });
    qs.querySelectorAll(OVERLAY).forEach(overlay => {
        overlay.addEventListener('click', evt => {
            if (evt.target.classList.contains(OVERLAY.replace(/^./, ''))) {
                closeHandler();
            }
        });
    });
}